import { useNavigate } from 'react-router-dom';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import clicksound from './music/click.mp3';

const ButtonBack = ({ setModalExit, score }) => {
  const navigate = useNavigate();
  const audio = new Audio(clicksound);

  const handleBackClick = () => {
    // Mainkan suara
    audio.play();
    if (score === 0) {
      navigate("/");
    } else {
      setModalExit(true);
    }
  };

  return (
    <button
      className="back-button lg:w-14 lg:h-14 sm:w-10 sm:h-10"
      onClick={handleBackClick}
    >
      <FontAwesomeIcon icon={faArrowLeft} className="lg:text-2xl sm:text-xl" />
    </button>
  );
};

export default ButtonBack;
